





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// DELETECONTACTUSSECTION
// DELETECONTACTUSSECTION


const DELETECONTACTUSSECTION= createAsyncThunk(
  "deleteContactUsSection/deleteContactUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const deleteContactUsSectionSlice = createSlice({
  name: "deleteContactUsSectionSlice",
  initialState: {
    deleteContactUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdeleteContactUsSection: (state) => {
        state.deleteContactUsSection.loading = false
        state.deleteContactUsSection.error = false
        state.deleteContactUsSection.data = []
        state.deleteContactUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DELETECONTACTUSSECTION.fulfilled, (state, action) => {
      state.deleteContactUsSection = {
        ...state.deleteContactUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETECONTACTUSSECTION.pending, (state, action) => {
      state.deleteContactUsSection = {
        ...state.deleteContactUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DELETECONTACTUSSECTION.rejected, (state, action) => {
      state.deleteContactUsSection = {
        ...state.deleteContactUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const deleteContactUsSectionAction = {
    DELETECONTACTUSSECTION,
};

export { deleteContactUsSectionAction };
export default deleteContactUsSectionSlice.reducer;
export const {setInitialStateOfdeleteContactUsSection} = deleteContactUsSectionSlice.actions
